(function () {
var $a3e8504aca44d495$exports = {};
const $a3e8504aca44d495$var$email = "qzehdxigrjmi.ztq@ta";
function $a3e8504aca44d495$var$showContactAdress() {
    const p = document.querySelector(".contact");
    p.innerHTML += `Contact: <a href="mailto:${$a3e8504aca44d495$var$decipher($a3e8504aca44d495$var$email)}?subject=L.O.W">${$a3e8504aca44d495$var$decipher($a3e8504aca44d495$var$email)}</a>`;
}
function $a3e8504aca44d495$var$decipher(txt) {
    const alpha = "abcdefghijklmnopqrstuvwxyz@-.";
    const cipher = "hsu@anwmopdfrqyit-xcbvzlke.gj";
    return txt.replace(/[a-z@\-\.]/gi, (l)=>cipher[alpha.indexOf(l)]);
}
$a3e8504aca44d495$var$showContactAdress();

})();
//# sourceMappingURL=index.e8433e9f.js.map
